import { render, staticRenderFns } from "./AccidentsReport.vue?vue&type=template&id=e0ada30c&scoped=true"
import script from "./AccidentsReport.vue?vue&type=script&lang=js"
export * from "./AccidentsReport.vue?vue&type=script&lang=js"
import style0 from "./AccidentsReport.vue?vue&type=style&index=0&id=e0ada30c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ada30c",
  null
  
)

export default component.exports